import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Text from './Text';
import Rating from './Rating/Rating';
import Select from './Select';
import Radio from './Radio/Radio';
import Checkbox from './Checkbox/Checkbox';
import File from './File';
import TandC from './TandC';
import SubscribeEdm from './SubscribeEdm';
import Date from './Date/Date';

const CustomFields = (props) => {
	const { t, i18n } = useTranslation();

	const {formFields, setFormFields, count, form_component} = props;

	//console.log(`input_type`, form_component.input_type);

	switch (form_component.input_type) {
		case 'text':
		case 'textarea':
		case 'number':
			return (
				<Text
					lang={props.lang}
					form_component={form_component}
				/>
			);

		case 'rating':
			return (
				<Rating
					lang={props.lang}
					form_component={form_component}
				/>
			);
		
		case 'select':
			return (
				<Select
					lang={props.lang}
					form_component={form_component}
					formFields={formFields}
				/>
			);

		case 'radio':
			return (
				<Radio
					lang={props.lang}
					form_component={form_component}
					formFields={formFields}
				/>
			);

		case 'checkbox':
			return (
				<Checkbox
					lang={props.lang}
					form_component={form_component}
					formFields={formFields}
				/>
			);

		case 'file':
			return (
				<File
					lang={props.lang}
					form_component={form_component}
				/>
			);
		case 'tandc':
			return (
				<TandC
					lang={props.lang}
					form_component={form_component}
				/>
			);

		case 'subscribe_edm':
			return (
				<SubscribeEdm
					lang={props.lang}
					form_component={form_component}
				/>
			);

		case 'date':
			return (
				<Date
					lang={props.lang}
					form_component={form_component}
				/>
			);
	}
}

export default CustomFields;